export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_05_blank.fce47f39.png";